// Small procedural details make the town readable without expensive full-screen effects.
import * as THREE from 'three';
export function addTownDetails(group) {
  const details = new THREE.Group();
  group.add(details);
  const wood = new THREE.MeshLambertMaterial({ color: '#76502f' }),
    sail = new THREE.MeshLambertMaterial({ color: '#fff0cc', side: THREE.DoubleSide });
  const rotor = new THREE.Group();
  rotor.position.set(14, 47, 18.6);
  details.add(rotor);
  for (let i = 0; i < 4; i++) {
    const arm = new THREE.Group();
    arm.rotation.z = (i * Math.PI) / 2;
    const bar = new THREE.Mesh(new THREE.BoxGeometry(0.14, 3.4, 0.16), wood);
    bar.position.y = 1.5;
    arm.add(bar);
    const cloth = new THREE.Mesh(new THREE.BoxGeometry(0.75, 1.9, 0.1), sail);
    cloth.position.set(0.35, 2, 0);
    arm.add(cloth);
    rotor.add(arm);
  }
  const tower = new THREE.Mesh(new THREE.CylinderGeometry(0.65, 1.1, 5, 4), new THREE.MeshLambertMaterial({ color: '#f0d5a2' }));
  tower.position.set(14, 43.5, 19);
  tower.castShadow = true;
  details.add(tower);
  const canvas = document.createElement('canvas');
  canvas.width = canvas.height = 256;
  const c = canvas.getContext('2d');
  c.fillStyle = '#fff7db';
  c.fillRect(0, 0, 256, 256);
  c.strokeStyle = '#765334';
  c.lineWidth = 12;
  c.strokeRect(6, 6, 244, 244);
  c.fillStyle = '#473626';
  c.font = 'bold 24px sans-serif';
  c.textAlign = 'center';
  c.textBaseline = 'middle';
  for (let n = 1; n <= 12; n++) {
    const a = (n * Math.PI) / 6;
    c.fillText(n, 128 + 88 * Math.sin(a), 128 - 88 * Math.cos(a));
  }
  c.lineWidth = 8;
  c.lineCap = 'round';
  c.beginPath();
  c.moveTo(128, 128);
  c.lineTo(128, 62);
  c.moveTo(128, 128);
  c.lineTo(172, 128);
  c.stroke();
  const tex = new THREE.CanvasTexture(canvas);
  tex.colorSpace = THREE.SRGBColorSpace;
  const face = new THREE.Mesh(new THREE.PlaneGeometry(2.7, 2.7), new THREE.MeshLambertMaterial({ map: tex }));
  face.position.set(17.5, 46, -5.01);
  face.rotation.y = Math.PI;
  details.add(face);
  const nest = new THREE.Mesh(new THREE.TorusGeometry(0.9, 0.17, 4, 12), wood);
  nest.rotation.x = Math.PI / 2;
  nest.position.set(4, 41.15, -5);
  details.add(nest);
  const butterflies = [];
  for (let i = 0; i < 9; i++) {
    const bug = new THREE.Group();
    const wings = [];
    for (const side of [-1, 1]) {
      const wing = new THREE.Mesh(
        new THREE.PlaneGeometry(0.24, 0.3),
        new THREE.MeshBasicMaterial({ color: ['#ffd057', '#ff8ec6', '#88eaff'][i % 3], side: THREE.DoubleSide }),
      );
      wing.position.x = side * 0.12;
      bug.add(wing);
      wings.push(wing);
    }
    details.add(bug);
    butterflies.push({ bug, wings, i });
  }
  return {
    dispose() {
      tex.dispose();
    },
    update(time, player) {
      rotor.rotation.z = time * 0.35;
      details.visible = Math.abs(player.x) < 80 && Math.abs(player.z) < 80;
      for (const { bug, wings, i } of butterflies) {
        const a = time * 0.35 + i * 2.4;
        bug.position.set(-16 + Math.cos(a) * 4, 42.1 + Math.sin(time * 1.7 + i) * 0.4, 5 + Math.sin(a * 0.7) * 8);
        bug.rotation.y = -a;
        wings.forEach((w, k) => (w.rotation.y = (k ? 1 : -1) * Math.sin(time * 13 + i) * 0.9));
      }
    },
  };
}
